<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm10 md8 lg6 justify-center d-flex>
            <v-card class="elevation-12 d-flex" style="height: 75vh; flex-direction: column">
              <v-toolbar dark color="primary" style="flex-grow: 0 !important;">
                <v-toolbar-title>GMaps ScreenShot Tool</v-toolbar-title>
              </v-toolbar>

              <v-tabs v-model="activeTab" style="flex-grow: 1; display: flex; flex-direction: column">
                <v-tab v-for="tab in tabs" :key="tab" ripple>
                  {{tab}}
                </v-tab>
                <v-tab-item v-for="tab in tabs" :key="tab">
                  <template v-if="!activeTab">
                    <v-card flat>
                      <v-card-text>
                        <v-form>
                          <v-textarea
                            v-model="url"
                            prepend-icon="mdi-web"
                            name="url"
                            label="URL"
                            type="text"
                            himt="">
                          </v-textarea>
                          <v-text-field
                            v-model="width"
                            prepend-icon="mdi-arrow-split-vertical"
                            name="width"
                            label="Width"
                            type="number"
                            persistent-hint
                            hint="ex.: A0: 9933, A1: 7016, A2: 4961">
                          </v-text-field>
                          <v-text-field
                            v-model="height"
                            prepend-icon="mdi-arrow-split-horizontal"
                            name="height"
                            label="Height"
                            type="number"
                            persistent-hint
                            hint="ex.: A0: 14043, A1: 9933, A2: 7016">
                          </v-text-field>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="send" :loading="loading">Trimite</v-btn>
                      </v-card-actions>
                    </v-card>
                  </template>
                  <template v-else>
                    <v-card flat>
                      <v-card-text style="overflow: auto; display: flex; flex-direction: column">
                        <v-pagination
                          v-if="thumbsLength"
                          style="flex: 0 0 auto !important; align-self: center"
                          circle
                          v-model="page"
                          :length="thumbsLength"
                          :total-visible="5"
                          class="pagination">
                        </v-pagination>
                        <v-container grid-list-sm fluid>
                          <v-layout row wrap>
                            <v-flex
                              v-for="thumb in pagedThumbs"
                              :key="thumb.src"
                              xs2
                              style="position: relative"
                              @mouseover="enterCard(thumb)"
                              @mouseout="leaveCard(thumb)">
                              <v-card flat tile>
                                <v-img :src="thumb.src" aspect-ratio="1" :lazy-src="lazySrc"></v-img>
                                <v-chip label class="caption pa-0 ma-0" color="white">
                                  <v-icon left class="mr-1" small style="font-size: 10px">mdi-calendar</v-icon>
                                  {{thumb.date}}
                                </v-chip>
                                <v-chip label class="caption pa-0 ma-0" color="white">
                                  <v-icon left class="mr-1" small style="font-size: 10px">mdi-timer</v-icon>
                                  {{thumb.time}}
                                </v-chip>
                              </v-card>
                              <v-card
                                flat
                                tile
                                style="position: absolute; top: 0; left: 0; width: 100%; align-items: center"
                                class="card-over"
                                :class="{
                                  'card-hidden': !activeCard || activeCard.filePath !== thumb.filePath,
                                  'card-visible': activeCard && activeCard.filePath === thumb.filePath
                                }">
                                <v-btn icon @click="download(thumb)">
                                  <v-icon color="green">
                                    mdi-download
                                  </v-icon>
                                </v-btn>
                                <v-btn icon @click="remove(thumb)">
                                  <v-icon color="red">
                                    mdi-delete
                                  </v-icon>
                                </v-btn>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </template>
                </v-tab-item>
              </v-tabs>
              <v-alert
                class="ma-0"
                dismissible
                v-model="errorVisible"
                type="error">
                {{error}}
              </v-alert>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios'

// const URL = 'https://gmaps-ss-tool.dragos.club'
const URL = 'https://gmaps-ss-tool.verdedata.ro'
// const URL = 'http://localhost:4444'

export default {
  name: 'App',
  data () {
    return {
      // url: 'https://www.google.ro/maps/@44.3990521,26.1035844,9192m/data=!3m1!1e3!4m2!6m1!1s14-jTivj4nTtf7aKpoYHlIepb0MTEW1fL?hl=ro',
      url: 'https://www.google.com/maps/d/u/1/edit?mid=1NAW_8gN0lguX_vwM6F-9Gj3hj9YsMnYT&ll=44.39964660168384%2C26.118095320000066&z=16',
      width: 7016,
      height: 9933,
      error: null,
      errorVisible: false,
      loading: false,
      fileName: '',
      tabs: ['formular', 'arhiva foto'],
      activeTab: null,
      thumbs: [],
      activeCard: null,
      page: 1,
      lazySrc: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IB2cksfwAAAAlwSFlzAAAOxAAADsQBlSsOGwAAAPBQTFRFAAAAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICADn+vwwAAAFB0Uk5TAB1st9f0tmscG5n7//2qH07yTW1J/P6UPzOV8RmcBUQRlj0+LWoGSEcBBLTZZsPCMvN/XE9dflJMU6DFxKLWVKFoaZp3ZZeYGkDwGEsUkbV8w0w/AAABJklEQVR4nGWSfVuCMBTFF6EIXEqwEMQQzbAiKsiCXqSisrS37/9t2sZF0M4/23N+ew7csxFSaEvYFhsNsSm1SF2yogJK29mt/LYONelG6Xc0WJMmFP7ePmxIa/N8mmN2LRtl9UwAp0/BAT3SLVPdwcAbUkOh/8mCRiXwAKxDaqgy6bDQcR2MmXNEmivgT479E8875SAgZxzYoe2fA1z4dnjJgUgiDmK4mrLN9BpuOIiIjiAx2Ca9ReBgVAx37j3AgztDkOHHYzAT10jdRxNBQCQEYD4lyYxOXYBn0mKFj/KqqBAHJC907fnhK+rNnVPjnc71wUocLsoSF3Mat/xkE0/+154WBQmbFyWV1aVO3V9+VZf+/bN6DKrSX38n+W8WRVmQy2j8AcmpKUDjceClAAAAAElFTkSuQmCC'
    }
  },
  watch: {
    errorVisible (v) {
      if (!v) this.error = null
    }
  },
  computed: {
    pagedThumbs () {
      return this.thumbs.slice((this.page - 1) * 24, this.page * 24)
    },
    thumbsLength () {
      return this.thumbs.length ? Math.ceil(this.thumbs.length / 24) : 0
    }
  },
  methods: {
    enterCard (thumb) {
      this.activeCard = thumb
    },
    leaveCard (thumb) {
      this.activeCard = null
    },
    remove (thumb) {
      axios.post(URL + '/remove', thumb)
        .then(response => {
          this.thumbs = this.thumbs.filter(t => t.filePath !== thumb.filePath)
        })
        .catch(error => {
          if (error && error.response && error.response.data && error.response.data.message) {
            this.error = error.response.data.message
          } else {
            this.error = String(error)
          }
          this.errorVisible = true
        })
    },
    download (thumb) {
      axios({
        url: thumb.filePath,
        method: 'GET',
        responseType: 'blob'
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', thumb.fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
        })
        .catch(error => {
          if (error && error.response && error.response.data && error.response.data.message) {
            this.error = error.response.data.message
          } else {
            this.error = String(error)
          }
          this.errorVisible = true
        })
    },
    send () {
      this.loading = true
      axios.post(URL, {
        url: this.url,
        width: this.width,
        height: this.height
      })
        .then(response => {
          this.fileName = response.data.filename
          this.loading = false

          let label = this.fileName.replace('ss_', '').replace('.png', '')
          let date = label.substring(0, 10)
          let time = label.substring(11).replace(/-/g, ':')

          const thumb = {
            filePath: `${URL}/ss/${this.fileName}`,
            src: `${URL}/thumbs/${this.fileName}`,
            date,
            time,
            fileName: this.fileName
          }

          this.thumbs.push(thumb)
          this.download(thumb)
        })
        .catch(error => {
          if (error && error.response && error.response.data && error.response.data.message) {
            this.error = error.response.data.message
          } else {
            this.error = String(error)
          }
          this.errorVisible = true
          this.loading = false
        })
    },
    getThumbs () {
      axios.get(URL + '/thumbs')
        .then(response => {
          this.thumbs = response.data.map(thumb => {
            let label = thumb
            label = label.replace('ss_', '').replace('.png', '')
            let date = label.substring(0, 10)
            let time = label.substring(11).replace(/-/g, ':')
            return {
              filePath: `${URL}/ss/${thumb}`,
              src: `${URL}/thumbs/${thumb}`,
              date,
              time,
              fileName: thumb
            }
          })
        })
        .catch(error => {
          if (error && error.response && error.response.data && error.response.data.message) {
            this.error = error.response.data.message
          } else {
            this.error = String(error)
          }
          this.errorVisible = true
        })
    }
  },
  created () {
    this.getThumbs()
  }
}
</script>

<style>
  .v-tabs .v-window {
    flex-grow: 1;
    display: flex;
    flex-direction: row;
  }

  .v-tabs .v-window .v-window__container {
     flex-grow: 1;
    display: flex;
  }

  .v-tabs .v-window .v-window__container .v-window-item {
    flex-grow: 1;
     display: flex;
  }

  .v-tabs .v-window .v-window__container .v-window-item .v-card {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }

  .v-tabs .v-window .v-window__container .v-window-item .v-card .v-card__text {
    flex-grow: 1;
  }

  .v-chip, .v-chip__content {
    height: 18px;
    line-height: 1;
    font-size: 10px;
    color: #666;
  }

  .card-hidden {
    /* display: none !important; */
    opacity: 0;
  }

  .card-visible {
    /* display: flex; */
    opacity: .75;
    transition: opacity .5s;
  }

  .pagination .v-pagination__item {
      min-width: 20px !important;
      height: 20px !important;
      font-size: 10px !important;
    }

  .pagination .v-pagination__navigation {
    width: 20px !important;
    height: 20px !important;
  }

  .pagination .v-pagination__navigation .v-icon {
    font-size: 14px !important;
  }
</style>
